import { useMemo } from 'react';
import type { TaskDetails } from '../../../../services/scraper';
import type { TasksDetailsResponse } from '../../../../api';
import { isSuccessDemoStatus } from '../utils';

export const useScrapingCounts = ({
  scrapingList,
  selectedTaskIds,
  isSelectAllMode,
  getExportableTaskIdsFromTasks,
}: {
  scrapingList: TasksDetailsResponse[];
  selectedTaskIds: string[];
  isSelectAllMode: boolean;
  getExportableTaskIdsFromTasks: (
    taskList: TaskDetails[],
    taskIdsToFilter: string[] | null
  ) => string[] | null;
}) => {
  const exportableTaskCount = useMemo(() => {
    const currentTasks = scrapingList?.[0]?.tasks || [];
    const exportableIds = getExportableTaskIdsFromTasks(
      currentTasks,
      isSelectAllMode ? null : selectedTaskIds
    );
    return exportableIds?.length || 0;
  }, [
    isSelectAllMode,
    scrapingList,
    selectedTaskIds,
    getExportableTaskIdsFromTasks,
  ]);

  const refreshableDemoTaskCount = useMemo(() => {
    const currentTasks = scrapingList?.[0]?.tasks || [];
    const tasksToCheck = isSelectAllMode
      ? currentTasks
      : currentTasks.filter((task: TaskDetails) =>
          selectedTaskIds.includes(task.id || '')
        );

    return tasksToCheck.filter((task: TaskDetails) =>
      isSuccessDemoStatus(task.status)
    ).length;
  }, [isSelectAllMode, scrapingList, selectedTaskIds]);

  return {
    exportableTaskCount,
    refreshableDemoTaskCount,
  };
};
